import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";

export default class TruncateBehavior extends AbstractDataAttributeBehaviour {

    selector = 'data-truncate';

    getContainerSelector()
    {
        return '[' + this.selector + ']';
    }

    createReadMore(){
        const el = document.createElement('a');
        el.textContent = ' Read More';
        el.className = 'read-more-link';

        return el;
    }

    handleReadMore(button, container, text){
        button.addEventListener('click', () => {
            container.innerHTML = text;
        });
    }

    initContainer(container)
    {
        const originalContent = container.innerHTML;
        const length = container.dataset.truncate;
        const button = this.createReadMore();

        container.innerHTML = container.innerHTML.slice(0, length) + '...';

        this.handleReadMore(button, container, originalContent);

        container.lastElementChild ? container.lastElementChild.append(button) : container.append(button);
    }
}